import { format } from 'date-fns'
import pluralize from 'pluralize'
import styled from 'styled-components'

import FiltersIcon from 'components/icons/Filters'
import { Filters } from '../types'

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme['-ds-neutral-100'].value};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border: 0;
  padding: 17px 14px;
  border-radius: 8px;
  width: 100%;

  svg {
    width: 20px;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme?.['-ds-core-400']?.value};
  }
`

const Label = styled.span<{ disabled?: boolean }>`
  letter-spacing: 0.01em;
  color: ${({ theme, disabled }) =>
    disabled
      ? theme?.['-ds-neutral-500']?.value
      : theme?.['-ds-neutral-700']?.value};
`

interface ModalButtonProps {
  filters: Omit<Filters, 'state' | 'country'>
  onClick: () => any
}

const datesLabel = ({
  startDate,
  endDate,
}: Pick<Filters, 'startDate' | 'endDate'>) => {
  const fomattedStart = startDate ? format(startDate, 'dd MMM') : 'Start'
  const fomattedEnd = endDate ? format(endDate, 'dd MMM') : 'End'
  return startDate || endDate ? `${fomattedStart} - ${fomattedEnd}` : ' Anytime'
}

const peopleLabel = ({
  adults,
  children,
  pets,
}: Pick<Filters, 'adults' | 'children' | 'pets'>) => {
  const count = adults + children
  const peopleText = count > 0 ? pluralize('people', count, true) : 'Anyone'
  if (pets && pets > 0) {
    return `${peopleText}, ${pluralize('pet', pets, true)}`
  }
  return peopleText
}

const ModalButton = ({ onClick, filters }: ModalButtonProps) => {
  const { startDate, endDate, adults, children, pets } = filters
  return (
    <Button type="button" onClick={onClick}>
      <span>
        <Label disabled={!startDate && !endDate}>{datesLabel(filters)}</Label>{' '}
        <span style={{ padding: '0 12px' }}>&#183;</span>
        <Label disabled={!adults && !children && !pets}>
          {peopleLabel(filters)}
        </Label>
      </span>
      <FiltersIcon />
    </Button>
  )
}

export default ModalButton
